export default __webpack_public_path__ + "static/media/ITR-2.dc22812e.png";